<template>
  <div>
    <of-dialog
      :title="formTitle"
      @onCancel="cancel"
      @onConfirm="confirm"
      :isConfirm="isConfirm"
    >
      <div slot="content">
        <el-form
          ref="dataForm"
          label-width="120px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="轮播模块：" prop="Plate">
            <p>{{ form.Plate }}</p>
          </el-form-item>
          <el-form-item label="名称：" prop="Title">
            <el-input
              v-model="form.Title"
              placeholder="请输入名称"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片：" prop="Files">
            <p>提示：宽度：250像素，高度：160像素</p>
            <of-upload
              class="upload-demo"
              :limit="1"
              list-type="picture-card"
              @onPreview="onPreview"
              @onRemove="onRemove"
              @onUpLoad="onUpload"
              :fileList="fileList"
              :class="{ hide: isHide }"
            >
              <div slot="content" style="margin-bottom: 20px">
                <i slot="default" class="el-icon-plus"></i>
              </div>
            </of-upload>
          </el-form-item>
          <el-form-item label="跳转链接：" prop="Link">
            <el-input v-model="form.Link" placeholder="请输入链接"></el-input>
          </el-form-item>
          <el-form-item label="截止时间：" prop="EndTime">
            <el-date-picker
              v-model="form.EndTime"
              type="datetime"
              value-format="timestamp"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </of-dialog>
  </div>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";

export default {
  components: {
    OfDialog,
    OfUpload,
  },
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isConfirm: false,
      form: {},
      rules: {
        Title: [{ required: true, message: "名称不能空", trigger: "blur" }],
        Link: [
          { required: true, message: "跳转链接不能不能空", trigger: "blur" },
        ],
        EndTime: [{ required: true, message: "请选择时间", trigger: "blur" }],
      },
      fileList: [],
      isHide: false,
    };
  },
  mounted() {
    const vm = this;
    vm.form = Object.assign({}, vm.dataForm);
    vm.form.EndTime = vm.dataForm.EndTime * 1000
    vm.fileList = JSON.parse(vm.form.Files);
    vm.isHide = true;
  },
  methods: {
    onUpload(file) {
      const vm = this;
      if (file.response.Code === 0) {
        vm.$message({
          message: "上传图片成功",
          type: "success",
        });
        vm.fileList = [
          {
            url: "/files" + file.response.Data.StorePath,
            id: file.response.Data.FileId,
          },
        ];
        vm.isHide = true;
      }
    },
    onRemove() {
      const vm = this;
      vm.fileList = [];
      vm.isHide = false;
    },
    onPreview() {},
    confirm() {
      const vm = this;
      if (vm.fileList.length === 0) {
        this.$message({
          message: "请上传图片",
          type: "error",
        });
        return;
      }
      vm.$refs.dataForm.validate((valid) => {
        if (valid) {
          let param = Object.assign({}, vm.form);
          param.Files = JSON.stringify(vm.fileList);
          param.EndTime = (param.EndTime / 1000).toFixed(0);
          vm.isConfirm = true;
          api
            .saveSlideShow(param)
            .then((res) => {
              if (res.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("onOk");
              } else {
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            })
            .finally(() => {
              vm.isConfirm = false;
            });
        }
      });
    },
    cancel() {
      const vm = this;
      vm.$emit("onOk");
    },
  },
};
</script>
<style scoped>
.hide .el-upload--picture-card {
  display: none;
}
.hide {
  display: block !important;
}
</style>
